import { type Link, useHead } from '@unhead/vue'
import { useAbsoluteUrl } from '@/composables/app/useAbsoluteUrl.ts'

export function useBlogFeedLink(): void {
    const absoluteUrl = useAbsoluteUrl()

    useHead({
        link: (): Link[] => {
            return [
                {
                    rel: 'alternate',
                    href: absoluteUrl('/stream/rss/blog').href,
                    type: 'application/rss+xml',
                },
                {
                    rel: 'alternate',
                    href: absoluteUrl('/stream/atom/blog').href,
                    type: 'application/atom+xml',
                },
            ]
        },
    })
}
